import React, { useState } from 'react';
import { User, Key, ArrowLeftRight, Plane, Star } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import MeuPerfilTab from './MeuPerfilTab';
import MinhaContaTab from './MinhaContaTab';
import PedidosTrocaTab from './PedidosTrocaTab';
import PedidosFeriasTab from './PedidosFeriasTab';
import MinhaAvaliacaoDesempenho from './MinhaAvaliacaoDesempenho';

const MeuPerfilContainer = ({ trocasPendentes = 0, onAtualizarTrocas }) => {
  const [activeSubTab, setActiveSubTab] = useState('perfil');

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold">Meu Perfil</h2>
        <p className="text-sm text-gray-600 mt-1">
          Gerir dados pessoais, conta, pedidos e avaliações
        </p>
      </div>

      <Tabs value={activeSubTab} onValueChange={setActiveSubTab}>
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="perfil" className="flex items-center gap-2">
            <User className="h-4 w-4" />
            Dados Pessoais
          </TabsTrigger>
          <TabsTrigger value="conta" className="flex items-center gap-2">
            <Key className="h-4 w-4" />
            Minha Conta
          </TabsTrigger>
          <TabsTrigger value="trocas" className="flex items-center gap-2 relative">
            <ArrowLeftRight className="h-4 w-4" />
            Trocas
            {trocasPendentes > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
                {trocasPendentes}
              </span>
            )}
          </TabsTrigger>
          <TabsTrigger value="ferias" className="flex items-center gap-2">
            <Plane className="h-4 w-4" />
            Férias
          </TabsTrigger>
          <TabsTrigger value="avaliacoes" className="flex items-center gap-2">
            <Star className="h-4 w-4" />
            Avaliações
          </TabsTrigger>
        </TabsList>

        <TabsContent value="perfil" className="mt-6">
          <MeuPerfilTab />
        </TabsContent>

        <TabsContent value="conta" className="mt-6">
          <MinhaContaTab />
        </TabsContent>

        <TabsContent value="trocas" className="mt-6">
          <PedidosTrocaTab onAtualizarContador={onAtualizarTrocas} />
        </TabsContent>

        <TabsContent value="ferias" className="mt-6">
          <PedidosFeriasTab />
        </TabsContent>

        <TabsContent value="avaliacoes" className="mt-6">
          <MinhaAvaliacaoDesempenho />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default MeuPerfilContainer;
